<template>
  <div>
    <el-dialog
      title="确认分配"
      :visible.sync="dialogVisible"
      width="700px"
      top="15px"
      @open="open"
      @close="close"
    >
      <el-table :data="tableData" border style="width: 100%" show-summary :summary-method="getSummaries">
        <el-table-column fixed type="index" width="50" label="序号" align="left" />
        <el-table-column prop="contractNum" :label="isDirect ? '换货合同号' : '合同号'" align="left" />
        <el-table-column prop="telegraphicTransferNum" label="电汇底单编号" align="left" />
        <el-table-column prop="actualAmount" label="实际结算金额" align="right" header-align="left" width="150" />
        <el-table-column v-if="this.$route.query.rcontractType ==='退货合同'" prop="assignAmount" label="本次分配金额" align="right" header-align="left" width="150">
          <template v-slot="{row}">
            <span>{{ row.assignAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="this.$route.query.rcontractType !=='退货合同'" prop="assignAmount" label="本次分配金额" align="right" header-align="left" width="150">
          <template v-slot="{row}">
            <span>{{ row.assignAmount }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" style="margin-top:20px" :loading="loading" @click="submit">
        确认分配
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import { contractToAssignInfoListTransfer } from '@/API/index.js';
import { numAdd } from '@/libs/util';

export default {

  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => { return {}; }
    },
    // 是否是直签分配
    isDirect: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      dialogVisible: this.dialogFormVisible,
      tableData: [],
      loading: false,
      sureData: {
        dialogData: [],
        contractType: '',
        contractId: 0
      }
    };
  },

  watch: {
    dialogFormVisible (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },

  methods: {
    open () {
      this.tableData = this.data.dialogData;
      this.sureData = this.data;
    },

    close () {
      this.tableData = [];
    },

    // 合计行的计算
    getSummaries ({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '本次分配金额') {
          sums[index] = data.reduce((pre, cur) => numAdd(cur.assignAmount, pre), 0);
        }
      });
      return sums;
    },

    // 确认分配按钮
    submit () {
      if (this.tableData.length === 0) {
        this.$message.error('请输入分配金额');
        return;
      }
      let assignInfoListVOList = [];

      this.sureData.dialogData.forEach((item) => {
        let obj = {
          telegraphicTransferNum: item.telegraphicTransferNum,
          assignAmount: item.assignAmount,
          businessEntity: item.bussinessEntity,
          allocationAmount: item.allocationAmount
        };
        if (this.$route.query.rcontractType === '退货合同') {
          obj.virtualFlag = item.virtualFlag;
        }
        assignInfoListVOList.push(obj);
      });

      let params = {
        id: this.sureData.contractId,
        contractNum: this.sureData.dialogData[0].contractNum,
        assignInfoListVOList: assignInfoListVOList
      };

      // 退货合同弹框提示
      if (this.$route.query.rcontractType === '退货合同') {
        this.$emit('on-ok', JSON.parse(JSON.stringify(params)));
        return false;
      }

      this.loading = true;
      contractToAssignInfoListTransfer(params).then((res) => {
        let { status } = res.data;
        this.loading = false;
        if (status === '200') {
          this.$message.success('分配成功');
          setTimeout(() => window.close(), 500);
          this.$router.back();
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  }

};
</script>
